<template>
  <div class="bind-success-container">
    <!-- 顶部装饰元素 -->
    <div class="decorative-top"></div>

    <!-- 主内容区 -->
    <div class="bind-success-card">
      <h1 class="title">会员卡关联成功</h1>
      <p class="description">
        已成功绑定公众号<br /><span class="highlight">{{ shop }}</span>
      </p>

      <!-- 公众号二维码展示区（可选） -->
      <!-- <div class="qrcode-placeholder">
        <div class="qrcode-mock"></div>
        <p>扫码关注公众号及时接收通知</p>
      </div> -->

      <!-- 操作按钮 -->
      <button @click="returnMp" class="close-button">返回小程序</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bindmp',
  data() {
    return {
      shop: '', // 替换为实际公众号名称
      isWechatMP: false,
    }
  },
  mounted() {
    // 检测是否在小程序环境
    this.isWechatMP = typeof wx !== 'undefined' && wx.miniProgram

    const companyID = localStorage.getItem('companyID')
    if (
      companyID === '60aa4076d35c97da155b85f9' ||
      companyID === '65dc54008120edcbe745ef1f' ||
      companyID === '62148f573c0a4c0fa305a0ff'
    ) {
      if (companyID === '62148f573c0a4c0fa305a0ff') {
        this.RequestLocalNew(
          'POST',
          '/mp/getUnionidByOpenid',
          { openid: localStorage.getItem('code') },
          (res) => {
            if (res.data.code === '20000') {
              console.log('绑定成功', res.data)
              // 这里可以更新绑定状态或公众号信息
            }
          },
          (err) => console.log(err)
        )
      } else {
        this.RequestLocal(
          'POST',
          '/mp/getUnionidByOpenid',
          { openid: localStorage.getItem('code') },
          (res) => {
            if (res.data.code === '20000') {
              console.log('绑定成功', res.data)
              // 这里可以更新绑定状态或公众号信息
            }
          },
          (err) => console.log(err)
        )
      }
    }
  },
  methods: {
    returnMp() {
      if (this.isWechatMP) {
        // 小程序环境
        wx.miniProgram.navigateBack()
        // 如果需要返回特定页面：
        // wx.miniProgram.switchTab({ url: '/pages/index/index' });
      } else {
        // 普通浏览器环境
        window.history.back()
      }
    },
  },
}
</script>

<style scoped>
/* 渐变色彩定义 */
:root {
  --primary-gradient: linear-gradient(317deg, #ff9c60 0%, #ff5a61 100%);
  --primary-light: rgba(255, 156, 96, 0.1);
}

.bind-success-container {
  width: 100%;
  min-height: 100vh;
  background: #f9f9f9;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.decorative-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  border-radius: 0 0 20% 20%;
  z-index: 0;
  background: linear-gradient(317deg, #ff9c60 0%, #ff5a61 100%);
}

.bind-success-card {
  width: 100%;
  max-width: 400px;
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(255, 94, 96, 0.15);
  position: relative;
  z-index: 1;
  text-align: center;
  margin-top: -80px;
  height: 200px;
}

.success-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
}

.success-icon svg {
  width: 100%;
  height: 100%;
}

.success-icon defs linearGradient {
}
stop:first-child {
  stop-color: #ff9c60;
}
stop:last-child {
  stop-color: #ff5a61;
}
.title {
  font-size: 18px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 600;
}

.description {
  color: #666;
  margin-bottom: 25px;
  font-size: 14px;
}

.highlight {
  color: #ff5a61;
  font-weight: bold;
}

.close-button {
  width: 100%;
  padding: 6px;
  background: linear-gradient(317deg, #ff9c60 0%, #ff5a61 100%);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 40px;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(255, 94, 96, 0.3);
}

.close-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 94, 96, 0.4);
}

.close-button:active {
  transform: translateY(0);
}
</style>


// WEBPACK FOOTER //
// src/bindmp/index.vue